var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.type && _vm.task
      ? _c("div", [
          _vm.type == 5
            ? _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-8" }, [
                    _c("h5", { staticClass: "alert alert-info" }, [
                      _vm._v("Смена адреса доставки - курьер: "),
                      _c("strong", [_vm._v(_vm._s(_vm.task.user.name))]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Новый адрес: "),
                      _c("strong", [_vm._v(_vm._s(_vm.task.text_data))]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group flex runners_select" },
                      [
                        _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.runner_opt,
                                expression: "runner_opt",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              id: "inlineRadio1",
                              value: "1",
                            },
                            domProps: { checked: _vm._q(_vm.runner_opt, "1") },
                            on: {
                              change: function ($event) {
                                _vm.runner_opt = "1"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "inlineRadio1" },
                            },
                            [_vm._v("Оставить за курьером")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.runner_opt,
                                expression: "runner_opt",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              type: "radio",
                              id: "inlineRadio3",
                              value: "3",
                            },
                            domProps: { checked: _vm._q(_vm.runner_opt, "3") },
                            on: {
                              change: function ($event) {
                                _vm.runner_opt = "3"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "inlineRadio3" },
                            },
                            [_vm._v("Сбросить заявку")]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Стоимость доставки"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.task.order.dost_price,
                                expression: "task.order.dost_price",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "number" },
                            domProps: { value: _vm.task.order.dost_price },
                            on: {
                              change: _vm.updatePrice,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.task.order,
                                  "dost_price",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Скидка"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.task.order.discount,
                                  expression: "task.order.discount",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: { value: _vm.task.order.discount },
                              on: {
                                change: _vm.updatePrice,
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.task.order,
                                    "discount",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.task.order.discount_type,
                                      expression: "task.order.discount_type",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.task.order,
                                          "discount_type",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.updatePrice,
                                    ],
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("Руб"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("%"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Стоимость заявки"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { type: "number", disabled: "" },
                        domProps: { value: _vm.task.order.total_price },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: { click: _vm.makeTaskAction },
                      },
                      [_vm._v("Подтвердить")]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type == 4
            ? _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-8" }, [
                    _c("h5", { staticClass: "alert alert-info" }, [
                      _vm._v("Смена количества препарата - курьер: "),
                      _c("strong", [_vm._v(_vm._s(_vm.task.user.name))]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Перапарат: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.getDrugNameById(_vm.task.text_data)) +
                            " - " +
                            _vm._s(_vm.task.num_data)
                        ),
                      ]),
                      _vm._v(" шт"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("В наличии на складе: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.inStores[_vm.task.order.city][
                              _vm.task.text_data
                            ]
                          )
                        ),
                      ]),
                      _vm._v(" шт"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Стоимость доставки"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.task.order.dost_price,
                                expression: "task.order.dost_price",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "number" },
                            domProps: { value: _vm.task.order.dost_price },
                            on: {
                              change: _vm.updatePrice,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.task.order,
                                  "dost_price",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Скидка"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.task.order.discount,
                                  expression: "task.order.discount",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: { value: _vm.task.order.discount },
                              on: {
                                change: _vm.updatePrice,
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.task.order,
                                    "discount",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.task.order.discount_type,
                                      expression: "task.order.discount_type",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.task.order,
                                          "discount_type",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.updatePrice,
                                    ],
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("Руб"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("%"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-8" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Новая стоимость заявки"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { type: "number", disabled: "" },
                        domProps: { value: _vm.task.order.total_price },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Старая стоимость заявки"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { type: "number", disabled: "" },
                        domProps: { value: _vm.oldPrice },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-8" }, [
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.task.system_comments,
                            expression: "task.system_comments",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: "Причина отказа на запрос",
                        },
                        domProps: { value: _vm.task.system_comments },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.task,
                              "system_comments",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-warning",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.makeTaskAction($event, "reject")
                              },
                            },
                          },
                          [_vm._v("Отказать")]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: {
                          click: function ($event) {
                            return _vm.makeTaskAction($event)
                          },
                        },
                      },
                      [_vm._v("Подтвердить")]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type == 3
            ? _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("h5", { staticClass: "alert alert-warning" }, [
                      _vm._v("Отмена заявки"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Причина: "),
                      _c("strong", [_vm._v(_vm._s(_vm.task.text_data))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info",
                        on: {
                          click: function ($event) {
                            return _vm.makeTaskAction($event)
                          },
                        },
                      },
                      [_vm._v("Подтвердить")]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type == 2
            ? _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("h5", { staticClass: "alert alert-warning" }, [
                      _vm._v("Перенос заявки"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Новая дата доставки: "),
                      _c("strong", [_vm._v(_vm._s(_vm.task.text_data))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info",
                        on: {
                          click: function ($event) {
                            return _vm.makeTaskAction($event)
                          },
                        },
                      },
                      [_vm._v("Ознакомлен")]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }